export default __webpack_public_path__ + "pgnv-assets/8d8a311adcebc242dbfa5ac0757bae5d.png";